import React, { Suspense, useEffect } from "react";
import { ToastProvider } from "react-toast-notifications";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../pages/Login/login";
import Employee from "../ProtectedRoutes/Employee";
import Partner from "../ProtectedRoutes/Partner";
import { connect } from "react-redux";
import Loader from "../common/Loader/Loader";
import NotificationModal from "../components/atoms/NotificationModal";
import { Paths } from "./path";
import ENV from "../Environments";
import * as LazyComponents from "./loadables";
import store from "../redux/store";
import { setScreenSize } from "../redux/actions/actions";
import { throttleFunction } from "../common/utility";
import Vendor from "../ProtectedRoutes/Vendor";
import Scm from "../ProtectedRoutes/Scm";

const AppRoutes = (props) => {
  const { dispatch } = store;
  let isMobile;
  let isTablet;

  const screenSpecs = () => {
    isMobile = window.innerWidth < 376 ? true : false;
    isTablet =
      window.innerWidth < 769 && window.innerWidth > 375 ? true : false;
    dispatch(setScreenSize({ isMobile, isTablet }));
  };
  const throttledHandleWindowResize = throttleFunction(() => {
    //Device size mobile,tablet
    screenSpecs();
  }, 100);

  useEffect(() => {
    screenSpecs();
    window.addEventListener("resize", throttledHandleWindowResize);
    return () => {
      window.removeEventListener("resize", throttledHandleWindowResize);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <NotificationModal />
      <Router basename={ENV.getBaseName()}>
        <ToastProvider>
          {props.loadingState && <Loader />}
          <Suspense
            fallback={
              <div className={"pos-rel top-overlay"}>
                <Loader />
              </div>
            }
          >
            <Routes>
              <Route path={"/"} element={<Login />} />
              {/* Employee Routes */}
              <Route
                exact
                path={Paths.internalDashboard.path}
                element={
                  <Employee>
                    <LazyComponents.EmpDashboardLazy />
                  </Employee>
                }
              />
              <Route
                exact
                path={Paths.userManagement.path}
                element={
                  <Employee>
                    <LazyComponents.UserManagementLazy />
                  </Employee>
                }
              />
              <Route
                path={Paths.neValidation.path}
                element={
                  <Employee>
                    <LazyComponents.NeValidationLazy />
                  </Employee>
                }
              />
              <Route
                exact
                path={Paths.addUser.path}
                element={
                  <Employee>
                    <LazyComponents.AddUserComponentLazy />
                  </Employee>
                }
              />
              <Route
                exact
                path={Paths.editUser.path}
                element={
                  <Employee>
                    <LazyComponents.EditUserComponentLazy />
                  </Employee>
                }
              />
              <Route
                exact
                path={Paths.approvalScreen.path}
                element={
                  <Employee>
                    <LazyComponents.ApprovalScreenLazy />
                  </Employee>
                }
              />
              <Route
                exact
                path={Paths.ticketTracker.path}
                element={
                  <Employee>
                    <LazyComponents.TicketTrackerScreenLazy />
                  </Employee>
                }
              />
              <Route
                path={Paths.licenseVerification.path}
                element={
                  <Employee>
                    <LazyComponents.LicenseVerificationLazy />
                  </Employee>
                }
              />
              <Route
                path={Paths.neApproval.path}
                element={
                  <Employee>
                    <LazyComponents.NeApprovalLazy />
                  </Employee>
                }
              />
              <Route
                path={Paths.bulkUpload.path}
                element={
                  <Employee>
                    <LazyComponents.BulkUploadLazy />
                  </Employee>
                }
              />
              <Route
                path={Paths.prospectEvaluation.path}
                element={
                  <Employee>
                    <LazyComponents.ProspectEvaluationLazy />
                  </Employee>
                }
              />
              <Route
                path={Paths.prospectEvaluatePartner.path}
                element={
                  <Employee>
                    <LazyComponents.EvaluatePartnerProspectLazy />
                  </Employee>
                }
              />
              <Route
                path={Paths.addprospect.path}
                element={
                  <Employee>
                    <LazyComponents.AddProspectLazy />
                  </Employee>
                }
              />
              <Route
                path={Paths.editProspect.path}
                element={
                  <Employee>
                    <LazyComponents.AddProspectLazy />
                  </Employee>
                }
              />
              <Route
                path={Paths.partnerFeedback.path}
                element={
                  <Employee>
                    <LazyComponents.PartnerFeedbackLazy />
                  </Employee>
                }
              />
              <Route
                path={Paths.addFeedback.path}
                element={
                  <Employee>
                    <LazyComponents.AddFeedbackLazy />
                  </Employee>
                }
              />
              <Route
                path={Paths.viewLcoDashboard.path}
                element={
                  <Employee>
                    <LazyComponents.ViewLcoDashboard />
                  </Employee>
                }
              />
              <Route
                path={Paths.polygonCreation.path}
                element={
                  <Employee>
                    <LazyComponents.PolygonCreation />
                  </Employee>
                }
              />
              <Route
                path={Paths.updateOrder.path}
                element={
                  <Employee>
                    <LazyComponents.OrderUpdate />
                  </Employee>
                }
              />
              <Route
                path={Paths.masterConfig.path}
                element={
                  <Employee>
                    <LazyComponents.MasterConfig />
                  </Employee>
                }
              />
              <Route
                path={Paths.customerDownTime.adminPath}
                element={
                  <Employee>
                    <LazyComponents.CustomerDownTime isAdminView={true} />
                  </Employee>
                }
              />
              <Route
                path={Paths.CDTDetails.adminPath}
                element={
                  <Employee>
                    <LazyComponents.CDTDetails isAdminView={true} />
                  </Employee>
                }
              />
              {/* Partner Routes */}
              <Route
                path={Paths.partnerDashboard.path}
                element={
                  <Partner
                    subUserAllowed={Paths.partnerDashboard.subUserAllowed}
                  >
                    <LazyComponents.PartnerDashboardLazy />
                  </Partner>
                }
              />
              <Route
                path={Paths.statusScreen.path}
                element={
                  <Partner>
                    <LazyComponents.StatusScreenLazy />
                  </Partner>
                }
              />
              <Route
                path={Paths.addLCOPartnership.path}
                element={
                  <Partner>
                    <LazyComponents.AddLCOPartnership />
                  </Partner>
                }
              />
              <Route
                path={Paths.partnerDashboardDetails.path}
                element={
                  <Partner
                    subUserAllowed={Paths.partnerDashboard.subUserAllowed}
                  >
                    <LazyComponents.PartnerDashboardDetail />
                  </Partner>
                }
              />
              <Route
                path={Paths.addLicense.path}
                element={
                  <Partner>
                    <LazyComponents.AddLicense />
                  </Partner>
                }
              />
              <Route
                path={Paths.partnerTicketTracker.path}
                element={
                  <Partner>
                    <LazyComponents.PartnerTicketTracker />
                  </Partner>
                }
              />
              <Route
                path={Paths.commissionSummary.path}
                element={
                  <Partner>
                    <LazyComponents.CommissionSummary />
                  </Partner>
                }
              />
              <Route
                path={Paths.cart.path}
                element={
                  <Partner>
                    <LazyComponents.Cart />
                  </Partner>
                }
              />
              <Route
                path={Paths.manageTeam.path}
                element={
                  <Partner>
                    <LazyComponents.ManageTeam />
                  </Partner>
                }
              />
              <Route
                path={Paths.manageOrders.path}
                element={
                  <Partner>
                    <LazyComponents.ManageOrders />
                  </Partner>
                }
              />
              <Route
                path={Paths.ironMan.path}
                element={
                  <Partner subUserAllowed={Paths.ironMan.subUserAllowed}>
                    <LazyComponents.IronMan />
                  </Partner>
                }
              />
              <Route
                path={Paths.orderDetail.path}
                element={
                  <Partner>
                    <LazyComponents.OrderDetail />
                  </Partner>
                }
              />
              <Route
                path={Paths.airtelAmbassador.path}
                element={
                  <Partner>
                    <LazyComponents.AirtelAmbassador />
                  </Partner>
                }
              />
              <Route
                path={Paths.changePassword.path}
                element={
                  <Partner>
                    <LazyComponents.ChangePassword />
                  </Partner>
                }
              />
              <Route
                path={Paths.orderInstallments.path}
                element={
                  <Partner>
                    <LazyComponents.OrderInstallments />
                  </Partner>
                }
              />
              <Route
                path={Paths.manageInvoices.path}
                element={
                  <Partner>
                    <LazyComponents.ManageInvoices />
                  </Partner>
                }
              />
              <Route
                path={Paths.customerDownTime.path}
                element={
                  <Partner>
                    <LazyComponents.CustomerDownTime />
                  </Partner>
                }
              />
              <Route
                path={Paths.CDTDetails.path}
                element={
                  <Partner>
                    <LazyComponents.CDTDetails />
                  </Partner>
                }
              />
              {/* vendor Routes */}
              <Route
                path={Paths.insuredUsers.path}
                element={
                  <Vendor>
                    <LazyComponents.InsuredUsers />
                  </Vendor>
                }
              />
              {/* FNF Routes */}
              <Route
                path={Paths.fnfInitiate.path}
                element={
                  <Employee>
                    <LazyComponents.FnfInitiate />
                  </Employee>
                  }
              />
              {/* marketplace routes */}
              <Route
                path={Paths.scmLogin.path}
                element={<LazyComponents.ScmLogin />}
              />
              <Route
                path={Paths.scmDashboard.path}
                element={
                  <Scm>
                    <LazyComponents.ScmDashboard />
                  </Scm>
                }
              />
              <Route
                path={Paths.scmProductCatalog.path}
                element={
                  <Scm>
                    <LazyComponents.ScmProductCatalog />
                  </Scm>
                }
              />
              <Route
                path={Paths.scmCart.path}
                element={
                  <Scm>
                    <LazyComponents.ScmCart />
                  </Scm>
                }
              />
              <Route />
              <Route
                path={Paths.scmOrders.path}
                element={
                  <Scm>
                    <LazyComponents.ScmMyOrders />
                  </Scm>
                }
              />
              <Route
                path={Paths.productDetail.path}
                element={
                  <Scm>
                    <LazyComponents.ProductPage />
                  </Scm>
                }
              />
              <Route
                path={Paths.scmBulkUpload.path}
                element={
                  <Scm>
                    <LazyComponents.ScmBulkUpload />
                  </Scm>
                }
              />
              <Route
                path={Paths.scmManageCatalog.path}
                element={
                  <Scm>
                    <LazyComponents.ScmManageCatalog />
                  </Scm>
                }
              />
              <Route
                path={Paths.widget.path}
                element={
                  <Partner>
                    <LazyComponents.OmniWidget />
                  </Partner>
                }
              />
            </Routes>
          </Suspense>
        </ToastProvider>
      </Router>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loadingState: state.loadingState,
  };
};

export default connect(mapStateToProps, null)(AppRoutes);
